/**
 * This file contains data shared between components. This approach
 * may change at a later date.
 */
export const sizes = {
    small: 'size-small',
    medium: 'size-medium',
    large: 'size-large',
};

export const variants = {
    primary: 'variant-primary',
    primaryDark: 'variant-primary-dark',
    secondary: 'variant-secondary',
    secondaryDark: 'variant-secondary-dark',
    tertiary: 'variant-tertiary',
    invisible: 'variant-invisible',
};

/**
 * These are shared prop definitions used in the `ButtonLink`
 * and `IconButtonLink` components.
 *
 * They are shared to cut down on code repetitions, and are
 * only needed in this edgecase because we're directly binding
 * props in the `IconButtonLink` component which in turn may
 * use the RouterLink component.
 */
export const propDefinitions = {
    variant: {
      type: String,
      required: false,
      default: 'primary',
      validator(value) {
        return Object.keys(variants).includes(value);
      },
    },
    size: {
      type: String,
      required: false,
      default: 'large',
      validator(value) {
        return Object.keys(sizes).includes(value);
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * The following props are added because our tests
     * use vue utils v1 and doesn't recognize RouterLink
     * object.
     *
     * Once we upgrade everything we can replace these
     * with `...Router.props`
     */
    to: {
      type: [String, Object],
      required: true,
    },
    replace: {
      type: Boolean,
      required: false,
    },
    append: {
      type: Boolean,
      required: false,
    },
    activeClass: {
      type: String,
      required: false,
    },
    exact: {
      type: Boolean,
      required: false,
    },
    exactPath: {
      type: Boolean,
      required: false,
    },
    exactPathActiveClass: {
      type: String,
      required: false,
    },
    exactActiveClass: {
      type: String,
      required: false,
    },
    ariaCurrentValue: {
      type: String,
      required: false,
    },
};
